import React from "react";
import { Modal, Space, Button, Typography, Tag } from "antd";
import { COLORS } from "../types/types";
import StripeWrapper from '../page/client/StripeWrapper';
import PaymentFormExport from '../page/client/PaymentFormExportCredits';

const { Text } = Typography;

interface CityExportModalProps {
  visible: boolean;
  city: any | null;
  calculation: any | null;
  amount: number;
  showPayment: boolean;
  userId: number | null;
  onCancel: () => void;
  onShowPayment: () => void;
  onSuccess: () => void;
  onExportCity: (city: any, contactCount: number) => Promise<void>; // ✅ AJOUTER CETTE PROP
}

const CityExportModal: React.FC<CityExportModalProps> = ({
  visible,
  city,
  calculation,
  amount,
  showPayment,
  userId,
  onCancel,
  onShowPayment,
  onSuccess,
  onExportCity, // ✅ DÉSTRUCTURER LA PROP
}) => {
  if (!city || !calculation) return null;

  // ✅ Gestionnaire de succès du paiement
  const handlePaymentSuccess = () => {
    if (city && calculation) {
      // Déclencher l'export après paiement réussi
      onExportCity(city, calculation.pricingDetails.recordCount || 0);
    }
    onSuccess();
  };

  // ✅ Détail du calcul pour la tarification par tranche
  const renderPriceDetails = () => {
    if (calculation.pricingModel === 'per_thousand' && calculation.pricingDetails.tranches) {
      return (
        <div style={{ 
          backgroundColor: COLORS.light, 
          padding: 16, 
          borderRadius: 8, 
          marginBottom: 16,
          textAlign: 'left'
        }}>
          <div style={{ fontSize: 14, color: COLORS.textLight, marginBottom: 8 }}>
            Détail du calcul :
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
            <span>Nombre de contacts :</span>
            <strong>{calculation.pricingDetails.recordCount}</strong>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
            <span>Taille de la tranche :</span>
            <strong>{calculation.pricingDetails.trancheSize} contacts</strong>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
            <span>Nombre de tranches (arrondi sup.) :</span>
            <strong>{calculation.pricingDetails.tranches}</strong>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
            <span>Prix par tranche :</span>
            <strong>{calculation.pricingDetails.pricePerTranche} €</strong>
          </div>
          <div style={{ 
            display: "flex", 
            justifyContent: "space-between", 
            marginTop: 8,
            paddingTop: 8,
            borderTop: `1px solid ${COLORS.border}`
          }}>
            <span style={{ fontWeight: "bold" }}>Total à payer :</span>
            <span style={{ fontWeight: "bold", color: COLORS.secondary }}>
              {calculation.pricingDetails.tranches} × {calculation.pricingDetails.pricePerTranche}€ = {amount.toFixed(2)} €
            </span>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <Modal
      title={
        <Space>
          <span role="img" aria-label="city" style={{ fontSize: "20px" }}>🏙️</span>
          Paiement sécurisé - Export par ville
        </Space>
      }
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={500}
      destroyOnClose
    >
      {!showPayment ? (
        <div style={{ padding: "24px 0", textAlign: "center" }}>
          {/* En-tête avec nom de la ville */}
          <div style={{ marginBottom: 24 }}>
            <Text strong style={{ fontSize: 18 }}>{city.name}</Text>
            <div style={{ marginTop: 8 }}>
              <Tag color="blue" style={{ fontSize: 14, padding: "4px 12px" }}>
                {calculation.pricingDetails.recordCount || 0} contacts
              </Tag>
            </div>
          </div>

          {/* Détail du calcul (pour la tarification par tranche) */}
          {renderPriceDetails()}

          {/* Montant à payer */}
          <div style={{ padding: 24, backgroundColor: COLORS.light, borderRadius: 8, marginBottom: 16 }}>
            <Text type="secondary">Montant à payer</Text>
            <div style={{ fontSize: 48, fontWeight: "bold", color: COLORS.secondary }}>
              {amount.toFixed(2)} €
            </div>
          </div>
          
          {/* Boutons d'action */}
          <Space>
            <Button onClick={onCancel}>Annuler</Button>
            <Button
              type="primary"
              onClick={onShowPayment}
              style={{ backgroundColor: COLORS.primary, borderColor: COLORS.primary }}
            >
              Payer {amount.toFixed(2)} €
            </Button>
          </Space>
        </div>
      ) : (
        <StripeWrapper>
          <PaymentFormExport
            amount={amount}
            userId={userId || 0}
            professionName={`Ville: ${city.name}`}
            fileName={`annuaire_${city.name}_${new Date().toISOString().slice(0, 10)}.xlsx`}
            onSuccess={handlePaymentSuccess}
            onCancel={onCancel}
          />
        </StripeWrapper>
      )}
    </Modal>
  );
};

export default CityExportModal;